import * as Accordion from "@radix-ui/react-accordion";
import { ComponentProps, forwardRef } from "react";

export const Content = forwardRef<
  HTMLDivElement,
  ComponentProps<typeof Accordion.Content>
>(({ children, ...props }, ref) => (
  <Accordion.Content ref={ref} asChild {...props}>
    {children}
  </Accordion.Content>
));

Content.displayName = "CustomTriggerAccordionGroup.Content";
